<template>
  <div class="row justify-center q-mb-lg">
    <q-field
      :value="value"
      borderless
      dense
      color="primary-app"
      v-bind="$attrs"
    >
      <q-avatar size="150px">
        <lwf-photo
          :picture="value"
          :empty-src="emptySrc"
          style="min-width: 150px"
        />
      </q-avatar>
      <div
        v-if="!readonly"
        class="text-center absolute-bottom q-gutter-sm"
        style="bottom: -18px;"
      >
        <btn-camera
          v-if="camera"
          :value="value"
          v-on="$listeners"
        />
        <lwf-btn-file
          :value="value"
          v-on="$listeners"
        />
      </div>
    </q-field>
  </div>
</template>
<script>
import BtnCamera from 'components/core/BtnCamera'
import LwfBtnFile from 'components/core/LwfBtnFile'
import LwfPhoto from 'components/core/LwfPhoto'
import propsReadonly from '@/mixins/propsReadonly'

export default {
  name: 'LwfPicture',
  components: { BtnCamera, LwfBtnFile, LwfPhoto },
  mixins: [propsReadonly],
  inheritAttrs: false,
  props: {
    value: {
      type: [String, Object],
      default: undefined
    },
    camera: Boolean,
    emptySrc: {
      type: String,
      default: undefined
    }
  }
}
</script>
